const styles = {
  root: {},

  reviewsContainer: {
    marginTop: 2,
    maxHeight: '100%',
    height: '100%',
    overflowY: 'scroll!important',
    WebkitOverflowScrolling: 'touch!important',
  },

  columnReviewHeight: {
    height: 370,
  },

  rowReviewHeight: {
    height: 245,
    WebkitOverflowScrolling: 'touch!important',
  },

}

export default styles
